import { ProfileApiDatasource } from '../data/datasources/profile-api.datasource';
import { ProfileRepositoryImpl } from '../data/repositories/profile.repository.impl';

const api = new ProfileApiDatasource();
const repository = new ProfileRepositoryImpl(api);

export const profileContainer = { repository };
